/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment'
import 'moment/locale/pt';

import ReactExport from "react-export-excel";
import axios from 'axios';
import { Box, Button, Typography } from '@mui/material';
import CustomizedTables from '../../../components/Table';
import FixedContainer from '../../../components/Container';
import LoadingComponent from '../../../components/LoadingComponent';
import { redirect, useNavigate } from 'react-router-dom';
import { GetFetch, urls } from '../../../services/apiBase';
import { useAppStatus } from '../../../hooks/app';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Geradas = () => {
  
  const [cprs, setCprs] = useState(null);
  const [cprBalance, setCprBalance] = useState([5, 2]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  
  const navigate = useNavigate()
  const { getCprSummarization } = useAppStatus();

  const COLUMNSTABLE = [
    {
      headerName: 'Identificação',
      type: 'default',
      value: {
        first: {
          parent: ['shared_personne'],
          value: 'name'
        },
        second: {
          value: 'nova_futura_id'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'N. da CPR',
      type: 'default',
      value: {
        first: {
          value: 'cpr_number'
        }
      }
    },
    {
      headerName: 'Data de geração',
      type: 'date',
      value: {
        first: {
          value: 'date_start'
        }
      }
    },
    {
      headerName: 'Data de ativação',
      type: 'date',
      value: {
        first: {
          value: 'date_signed'
        }
      }
    },
    {
      headerName: 'Data final',
      type: 'date',
      value: {
        first: {
          value: 'date_end'
        }
      }
    },
    {
      headerName: 'Valor investido',
      type: 'money',
      value: {
        first: {
          value: 'amount_cpr'
        }
      }
    },
    {
      headerName: 'Taxa',
      type: 'percent',
      value: {
        first: {
          value: 'rate_cpr'
        }
      }
    },
    {
      headerName: 'Saldo em conta',
      type: 'money',
      value: {
        first: {
          value: 'balance'
        },
      },
      noData: Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(0)
    },
    {
      headerName: 'Bois alocados',
      type: 'default',
      value: {
        first: {
          parent: ['cprs_farmhouse', 'farmhouse'],
          value: 'name'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Status pendente',
      type: 'default',
      value: {
        first: {
          parent: ['flowType', 'event_flows'],
          value: 'flow_description'
        }
      },
      noData: 'Não informado'
    },
    {
      headerName: 'Status',
      type: 'default',
      value: {
        first: {
          value: 'status'
        }
      }
    },
    {
      headerName: 'Tipo',
      type: 'default',
      value: {
        first: {
          value: 'type'
        }
      }
    },
  ]

  const getCPR = useCallback(async () => {
    setLoading(true)
    try {

      const response = await GetFetch(urls.GET_CPR_GERADAS);

      if (!response.data.error) {
        const ordered = response.data.sort((a, b) => a.cpr_number < b.cpr_number ? 1 : -1);
        setCprs(ordered);
      } else {
        setCprs('No momento não há CPRS geradas')
      }
      setError(false)

    } catch (error) {
      console.log(error)
      setError(true)
    } finally {
      setLoading(false);
    }
  }, []);

  const handleOpenDetails = (cpr) => {
    return navigate('/cprf/details', { state: { cpr: cpr } })
  }

  const getCPRBalance = useCallback(async () => {
    try {

      const cprBalance = await GetFetch(urls.GET_CPR_BALANCE);
      const cprBalanceArray = JSON.parse(cprBalance.data[0].value);

      if (cprBalanceArray.length > 0) {
        setCprBalance(cprBalanceArray);
      }

    } catch (error) {
      console.log(error)
    }
  }, []);

  
  const balanceStatus = (cpr) => {
    const today = moment.utc()
    const signData = moment.utc(cpr.date_signed);
    const diferenceDays = signData.diff(today, 'days');
    
    const [yellow, red] = cprBalance;
    
    if (diferenceDays < 0) {
      return ''
    }
    
    if (diferenceDays > yellow) {
      return ''
    }
    
    if (diferenceDays <= yellow && diferenceDays > red) {
      
      if (cpr.balance >= cpr.amount_cpr) {
        return 'green'
      }
      
      return 'yellow'
    }
    
    if (diferenceDays <= red) {
      
      if (cpr.balance >= cpr.amount_cpr) {
        return 'green'
      }

      return '#FF7769'
    }
    
  }

  const errorMessage = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'center'
      }}>
        <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '24px', paddingBottom: 2, color: 'red' }}>
          Ocorreu um erro ao buscar os cupons
        </Typography>
      </Box>
    )
  }

  const tableComponent = () => {
    return (
      <Box>
        <CustomizedTables
          data={cprs}
          columns={COLUMNSTABLE}
          options
          action={handleOpenDetails}
          dataColorChange={balanceStatus}
        />
      </Box>
    )
  }

  const exportExcelComponent = () => {
    return (
      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end'
      }}>
        <ExcelFile element={
          // <Button color="warning">Exportar para Excel</Button>
          <Button variant="contained" sx={{ marginBottom: 1 }}>Exportar para Excel</Button>
        } filename="cpr_abertas">
          <ExcelSheet data={cprs} name="cpr_abertas">
            <ExcelColumn label="Identificação_do_investidor" value={(col) => col.shared_personne ? col.shared_personne.name : (col.nova_futura_id ? 'MIGRAÇÃO NOVA FUTURA #' + col.nova_futura_id : "Não informado")} />
            <ExcelColumn label="Número_da_CPR" value="cpr_number" />
            <ExcelColumn label="Data_de_início" value={(col) => moment.utc(col.date_start).format('L')} />
            <ExcelColumn label="Data_final" value={(col) => moment.utc(col.date_end).format('L')} />
            <ExcelColumn label="Valor_investido" value={(col) => col.amount_cpr + ' ' + col.currency} />
            <ExcelColumn label="Taxa" value='rate_cpr' />
            <ExcelColumn label="Bois alocados" value={(col) => col.cprs_farmhouse.length > 0 ? col.cprs_farmhouse[0].farmhouse.name : "Não informado"} />
            <ExcelColumn label="Status" value='status' />
            <ExcelColumn label="Tipo" value='type' />
          </ExcelSheet>
        </ExcelFile>
      </Box>
    )
  }
  
  useEffect(() => {
    getCPR();
    getCPRBalance();
  }, [getCPR]);

  useEffect(() => {
    getCprSummarization();
  }, []);

  return (
    <FixedContainer>
      <Box sx={{
        width: '100%',
        height: '100%',
        backgroundColor: '#F9FBFD',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        boxShadow: 3,
        borderRadius: '10px',
        padding: 2,
      }}>
        {loading ? <LoadingComponent /> :
          error ? errorMessage() :
          cprs === 'No momento não há CPRS geradas' ? 
            <Box sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center'
            }}>
              <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 2 }}>
                No momento não há CPRS geradas
              </Typography>
            </Box>
            :
            <>
              <Typography variant='h6' sx={{ fontWeight: 700, fontSize: '18px', paddingBottom: 1 }}>
                CPRF's/Geradas
              </Typography>

              {exportExcelComponent()}
              {tableComponent()}
            </>
        }
      </Box>
    </FixedContainer>
  );
}

export default Geradas;
